import { Fragment } from 'react';
import { Box, Card, Typography, useTheme } from '@mui/material';
import { summaryHeaderStyles } from './SummaryHeader.styles';

export interface SummaryHeaderItem {
  value: number;
  label: string;
}

export interface SummaryHeaderProps {
  items: SummaryHeaderItem[];
  separators?: string[];
}

export const SummaryHeader = ({ items, separators = [] }: SummaryHeaderProps) => {
  const theme = useTheme();

  return (
    <Box sx={summaryHeaderStyles.container(theme)} role="list" aria-label="summary header">
      {items.map((item, index) => (
        <Fragment key={`${item.label}-${index}`}>
          <Card sx={summaryHeaderStyles.card(theme)} role="listitem">
            <Typography component="h4" sx={summaryHeaderStyles.value(theme)}>
              {item.value}
            </Typography>
            <Typography component="div" sx={summaryHeaderStyles.label(theme)}>
              {item.label}
            </Typography>
          </Card>
          {index < items.length - 1 && separators[index] && (
            <Box sx={summaryHeaderStyles.separatorContainer(theme)}>
              <Typography component="div" sx={summaryHeaderStyles.separator(theme)}>
                {separators[index]}
              </Typography>
            </Box>
          )}
        </Fragment>
      ))}
    </Box>
  );
};

export default SummaryHeader;
